import { render, staticRenderFns } from "./404.vue?vue&type=template&id=fd69a0b8&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd69a0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd69a0b8')) {
      api.createRecord('fd69a0b8', component.options)
    } else {
      api.reload('fd69a0b8', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=fd69a0b8&scoped=true", function () {
      api.rerender('fd69a0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/exception/404.vue"
export default component.exports